import { Datagrid, DateField, List, TextField } from "react-admin";

function PostList(props) {
  return (
    <List {...props}>
      <Datagrid>
        <TextField source="id" />
        <DateField source="postDate" />
        <TextField source="content" />
      </Datagrid>
    </List>
  );
}

export default PostList;
